function o(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
export {
  o as getDefaultExportFromCjs
};
//# sourceMappingURL=index.es117.js.map
